import { render } from "./DeviceInfo.vue?vue&type=template&id=24cde1b4&scoped=true&ts=true"
import script from "./DeviceInfo.vue?vue&type=script&lang=ts"
export * from "./DeviceInfo.vue?vue&type=script&lang=ts"

import "./DeviceInfo.vue?vue&type=style&index=0&id=24cde1b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24cde1b4"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QAvatar,QBtn,QTooltip,QIcon,QSeparator});
